import React, { useState, useEffect } from 'react';
import logo from '../assets/images/9works_Logo/svg/9works_Original_White.svg';
import logoDark from '../assets/images/9works_Logo/svg/9works_Original_Black.svg';

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, id) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <div className="navbar-inner">
        <a href="/" className="navbar-logo">
          <img src={scrolled ? logoDark : logo} alt="9works" />
        </a>

        <ul className={`navbar-links${mobileOpen ? ' open' : ''}`}>
          <li><a href="#features" onClick={(e) => handleNavClick(e, 'features')}>Features</a></li>
          <li><a href="#how-it-works" onClick={(e) => handleNavClick(e, 'how-it-works')}>How It Works</a></li>
          <li><a href="#modules" onClick={(e) => handleNavClick(e, 'modules')}>Modules</a></li>
          <li><a href="#why-9works" onClick={(e) => handleNavClick(e, 'why-9works')}>Why 9works</a></li>
          <li><a href="#contact" onClick={(e) => handleNavClick(e, 'contact')}>Contact</a></li>
          <li className="mobile-menu-cta">
            <a href="https://9works.in/organisation-portal" className="btn btn-primary" target="_blank" rel="noopener noreferrer" style={{ width: '100%', justifyContent: 'center', marginTop: '8px' }}>
              Get Started
            </a>
          </li>
        </ul>

        <div className="navbar-cta" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
          <a href="https://9works.in/organisation-portal" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
            Get Started
          </a>
          <button className={`navbar-mobile-toggle${mobileOpen ? ' active' : ''}`} onClick={() => setMobileOpen(!mobileOpen)} aria-label="Menu">
            <span></span><span></span><span></span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
